export type ViewMode = "web" | "overwolf" | "discord-activities";

export function getViewMode(): ViewMode {
    // Check if we're in Discord Activities by looking for frame_id parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("frame_id")) {
        return "discord-activities";
    }

    // Check if we're in Overwolf
    if (window.navigator.userAgent.includes("Overwolf")) {
        return "overwolf";
    }

    // Default to web
    return "web";
}